import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import { supabase } from '../../lib/supabaseClient.ts';
import { useNavigate } from "react-router-dom";

// Main category list with icons
const categoriess = [
  {
    name: "Alimentation",
    image: "img/icons/alm.jpg",
    subcategories: ["Croquettes", "Boîtes & Pochon & Barquette", "Friandises", "Compléments alimentaires"]
  },
  {
    name: "Hygiène et soins",
    image: "img/icons/hyg.jpeg",

    subcategories: ["Produits antiparasitaires", "Produits d'hygiène", "Matériel toilettage"]
  },
  {
    name: "Couchages", image: "img/icons/couche.jpg",
  },
  {
    name: "Gamelles et accessoires", image: "img/icons/gamellee.png",
  },
  {
    name: "Jouets", image: "img/icons/jou.jpg",
  },
  {
    name: "Niches et cages", image: "img/icons/nichee.jpg",
  },
  {
    name: "Sellerie",
    image: "img/icons/sell.jpg",

    emptyMessage: "Aucun produit ne correspond à votre sélection 🐾"

  }
];

// Subcategories for Alimentation
const subcategories = [
  "Croquettes",
  "Boîtes & Pochon & Barquette",
  "Friandises",
  "Compléments alimentaires",

];
const hygieneSubcategories = [
  "Produits d'hygiène",
  "Produits antiparasitaires",
  "Matériel toilettage"
];
const brands = [
  "STEFANPLAST",
  "CROCI",
];

const products = [
  // Alimentation > Croquettes
  { id: 1, name: "Brit Care Hypoallergénique", category: "Alimentation", subcategory: "Croquettes", priceRange: "65,000DT – 269,000DT", image: "img/product/britcare.jpg" },
  { id: 2, name: "Brit Care Mini Sans Céréales", category: "Alimentation", subcategory: "Croquettes", priceRange: "17,000DT – 69,000DT", image: "img/product/mini.png" },
  { id: 3, name: "Brit Fresh", category: "Alimentation", subcategory: "Croquettes", priceRange: "45,000DT – 210,000DT", image: "img/product/fresh.png" },
  { id: 4, name: "Brit Premium by Nature", category: "Alimentation", subcategory: "Croquettes", priceRange: "45,000DT – 220,000DT", image: "img/product/premium.png" },
  { id: 5, name: "BROKATON CHIEN", category: "Alimentation", subcategory: "Croquettes", priceRange: "171,000DT – 242,000DT", image: "img/product/brokaton.jpg" },
  { id: 6, name: "COTAGRO CHIEN", category: "Alimentation", subcategory: "Croquettes", priceRange: "198,000DT – 210,000DT", image: "img/product/cotagroadult.jpg" },
  { id: 7, name: "DOG VET SOLUTION", category: "Alimentation", subcategory: "Croquettes", priceRange: "93,000DT – 395,000DT", image: "img/product/dogvet.png" },
  { id: 8, name: "Royal Canin Maxi", category: "Alimentation", subcategory: "Croquettes", priceRange: "135,000DT – 355,000DT", image: "img/product/maxi.jpg" },
  { id: 9, name: "Royal Canin Medium", category: "Alimentation", subcategory: "Croquettes", priceRange: "140,000DT – 355,000DT", image: "img/product/medium.jpg" },
  { id: 10, name: "Royal Canin Mini", category: "Alimentation", subcategory: "Croquettes", priceRange: "95,000DT – 100,000DT", image: "img/product/miniiroyale.jpg" },


  // Example other categories
  { id: 11, name: "Panier Douillet", category: "Couchages", image: "img/product/panier.jpg" },
  { id: 12, name: "Gamelle Inox", category: "Gamelles et accessoires", image: "img/product/gamelle.jpg" },

  // Alimentation > Boîtes

  { id: 13, name: "BOITE DR CLAUDERS 800g", category: "Alimentation", subcategory: "Boîtes & Pochon & Barquette", priceRange: "21,500DT", image: "img/product/clauder.jpg" },

  { id: 14, name: "Boite Pâté Brit Premium By Nature 800 G", category: "Alimentation", subcategory: "Boîtes & Pochon & Barquette", priceRange: "14,000DT", image: "img/product/brit.jpg" },

  { id: 15, name: "Boites Pour Chien Brit Pâté Super Premium 800 G", category: "Alimentation", subcategory: "Boîtes & Pochon & Barquette", priceRange: "17,000DT", image: "img/product/premiumbrite.jpg" },

  { id: 16, name: "PATE CHIEN 4X300GR POULET & DINDE", category: "Alimentation", subcategory: "Boîtes & Pochon & Barquette", priceRange: "30,500DT", image: "img/product/plaisir.png" },

  { id: 17, name: "POCHON CARNILOVE CHIEN", category: "Alimentation", subcategory: "Boîtes & Pochon & Barquette", priceRange: "13,000DT", image: "img/product/carnilove.jpg" },

  // Alimentation > Barquette
  // Alimentation > Friandises

  { id: 18, name: "Jerky Time Mini Os au Poulet enrichis en Calcium 90g", category: "Alimentation", subcategory: "Friandises", priceRange: "14,000DT", image: "img/product/jerky.jpg" },

  { id: 19, name: "Jerky Time Sandwich au Poulet et Cabillaud 90g", category: "Alimentation", subcategory: "Friandises", priceRange: "14,000DT", image: "img/product/sandwich.jpeg" },

  { id: 20, name: "RECOMPENSE CARNILOVE CHIEN", category: "Alimentation", subcategory: "Friandises", priceRange: "14,000DT", image: "img/product/boie.jpg" },

  { id: 21, name: "Truly Croissants au Poulet 90g", category: "Alimentation", subcategory: "Friandises", priceRange: "12,000DT", image: "img/product/truly.jpg" },

  { id: 22, name: "Truly Mini Os 90g", category: "Alimentation", subcategory: "Friandises", priceRange: "14,000DT", image: "img/product/minoos.jpg" },

  { id: 23, name: "Truly Sticks au Poulet et Fromage 90g", category: "Alimentation", subcategory: "Friandises", priceRange: "14,000DT", image: "img/product/stick.jpg" },

  // Alimentation > Friandises

  { id: 24, name: "Canvit + Articulation", category: "Alimentation", subcategory: "Compléments alimentaires", priceRange: "35,000DT – 159,000DT", image: "img/product/canvitart.jpeg" },

  { id: 25, name: "Canvit BARF Collagen and Rosehip 140g", category: "Alimentation", subcategory: "Compléments alimentaires", priceRange: "44,000DT – 119,000DT", image: "img/product/barf.jpeg" },

  { id: 26, name: "Canvit + Vitamines", category: "Alimentation", subcategory: "Compléments alimentaires", priceRange: "29,000DT – 99,000DT", image: "img/product/vitamins.jpeg" },

  { id: 27, name: "Canvit Brit Care Poiles et Peau", category: "Alimentation", subcategory: "Compléments alimentaires", priceRange: "26,000DT – 65,000DT", image: "img/product/skin.jpg" },


  // 🛏️ Couchages
  { id: 28, name: "Maisonnette Blue Rose 40*42*42", category: "Couchages", priceRange: "139,000DT", image: "img/product/blue-rose.jpg" },
  { id: 29, name: "Maisonnette Oxford 47*46*40", category: "Couchages", priceRange: "119,000DT", image: "img/product/oxford.jpg" },
  { id: 30, name: "Maisonnette Vivi 55*55*55", category: "Couchages", priceRange: "169,000DT", image: "img/product/vivi-maison.jpg" },

  { id: 31, name: "Matelas Outdoor Maxi Marron 80*60*6cm", category: "Couchages", priceRange: "85,000DT", image: "img/product/matelas-80.jpg" },
  { id: 32, name: "Matelas Outdoor Maxi Marron 100*70*6cm", category: "Couchages", priceRange: "105,000DT", image: "img/product/matelas-100.jpg" },
  { id: 33, name: "Matelas Outdoor Maxi Marron 120*80*6cm", category: "Couchages", priceRange: "125,000DT", image: "img/product/matelas-120.jpg" },

  { id: 34, name: "Matelas Vivi 110*90*15 cm", category: "Couchages", priceRange: "345,000DT", image: "img/product/matelas-vivi-110.jpg" },
  { id: 35, name: "Matelas Vivi 90*75*15 cm", category: "Couchages", priceRange: "265,000DT", image: "img/product/matelas-vivi-90.jpg" },

  { id: 36, name: "Panier de Couchage Milan 63*48 cm", category: "Couchages", priceRange: "139,000DT", image: "img/product/panier-milan.jpg" },
  { id: 37, name: "Panier de Couchage Pablo 65*50 cm", category: "Couchages", priceRange: "165,000DT", image: "img/product/panier-pablo.jpg" },
  { id: 38, name: "Panier de Couchage Premium 63*48", category: "Couchages", priceRange: "129,000DT", image: "img/product/panier-premium.jpg" },
  { id: 39, name: "Panier de Couchage Vivi 65*50 cm", category: "Couchages", priceRange: "189,000DT", image: "img/product/panier-vivi-65.jpg" },
  { id: 40, name: "Panier de Couchage Vivi 75*60 cm", category: "Couchages", priceRange: "229,000DT", image: "img/product/panier-vivi-75.jpg" },
  // Liste des accessoires
  { id: 41, name: "Brosse ramasse poils Froggy", category: "Gamelles et accessoires", priceRange: "24,000DT", image: "img/product/brosse-froggy.jpeg" },

  { id: 42, name: "Imac Dido 50 Coussin pour Chien et Chat Anthracite 50 x 38 x 20,5 cm", category: "Gamelles et accessoires", priceRange: "125,000DT", image: "img/product/imac-dido50-coussin.jpg" },

  { id: 43, name: "Imac Dido 65 Coussin pour Chien et Chat Anthracite 50 x 38 x 20,5 cm", category: "Gamelles et accessoires", priceRange: "39,000DT", image: "img/product/imac-dido50-coussin.jpg" },

  { id: 44, name: "Doseur électronique", category: "Gamelles et accessoires", priceRange: "59,000DT", image: "img/product/doseur-electronique.jpg" },

  { id: 45, name: "Scoop Pince Pliante 66×15,5×13,5 cm", category: "Gamelles et accessoires", priceRange: "55,000DT", image: "img/product/scoop-pince-pliante.jpg" },

  { id: 46, name: "Support pour Tapis Absorbant 60×60", category: "Gamelles et accessoires", priceRange: "79,000DT", image: "img/product/support-tapis-absorbant.jpg" },
  // Matériel toilettage
  { id: 50, name: "Brosses à dents doubles", category: "Hygiène et soins", hygieneSubcategories: "Matériel toilettage", priceRange: "16,000DT", image: "img/product/brosse-dents-doubles.jpeg" },
  { id: 51, name: "Ciseaux de Toilettage à Effiler", category: "Hygiène et soins", hygieneSubcategories: "Matériel toilettage", priceRange: "37,000DT", image: "img/product/ciseaux-effiler.jpg" },
  { id: 52, name: "Ciseaux de Toilettage Courbés", category: "Hygiène et soins", hygieneSubcategories: "Matériel toilettage", priceRange: "39,000DT", image: "img/product/ciseaux-courbes.jpeg" },
  { id: 53, name: "Ciseaux de Toilettage Droits", category: "Hygiène et soins", hygieneSubcategories: "Matériel toilettage", priceRange: "37,000DT", image: "img/product/ciseaux-droits.jpeg" },
  { id: 54, name: "Coupe Griffes Petit Modèle", category: "Hygiène et soins", hygieneSubcategories: "Matériel toilettage", priceRange: "15,000DT", image: "img/product/coupe-griffes.jpg" },
  { id: 55, name: "Peigne anti-puces 5X7CM", category: "Hygiène et soins", hygieneSubcategories: "Matériel toilettage", priceRange: "9,000DT", image: "img/product/peigne-anti-puces.jpg" },
  { id: 56, name: "Serviette ultra absorbante en microfibres L", category: "Hygiène et soins", hygieneSubcategories: "Matériel toilettage", priceRange: "54,000DT", image: "img/product/serviette-l.jpg" },
  { id: 57, name: "Serviette ultra absorbante en microfibres M", category: "Hygiène et soins", hygieneSubcategories: "Matériel toilettage", priceRange: "34,000DT", image: "img/product/serviette-m.jpeg" },
  { id: 58, name: "Set de brosses à dents", category: "Hygiène et soins", hygieneSubcategories: "Matériel toilettage", priceRange: "12,000DT", image: "img/product/set-brosses.jpg" },

  // Produits antiparasitaires
  { id: 59, name: "Shampoing 300ml / Démêlant MENFORSAN", category: "Hygiène et soins", hygieneSubcategories: "Produits antiparasitaires", priceRange: "20,000DT – 39,000DT", image: "img/product/shampoing.jpg" },
  { id: 60, name: "Shampoing MEN FOR SAN 1L", category: "Hygiène et soins", hygieneSubcategories: "Produits antiparasitaires", priceRange: "39,000DT – 59,000DT", image: "img/product/shampoing-menforsan-1l.jpg" },
  { id: 61, name: "Shampoing MEN FOR SAN 5 L", category: "Hygiène et soins", hygieneSubcategories: "Produits antiparasitaires", priceRange: "119,000DT – 149,000DT", image: "img/product/shampoing-menforsan-5l.png" },

  // Produits d'hygiène
  { id: 62, name: "2 Rouleaux Adhésifs 100 Feuilles", category: "Hygiène et soins", hygieneSubcategories: "Produits d'hygiène", priceRange: "18,000DT", image: "img/product/rouleaux-100.jpg" },
  { id: 63, name: "2 Rouleaux Adhésifs 60 Feuilles", category: "Hygiène et soins", hygieneSubcategories: "Produits d'hygiène", priceRange: "14,000DT", image: "img/product/rouleaux-60.jpg" },
  { id: 64, name: "Brosse à dents triple tête", category: "Hygiène et soins", hygieneSubcategories: "Produits d'hygiène", priceRange: "24,000DT", image: "img/product/brosse-dents-triple.jpg" },
  { id: 65, name: "Brosse ramasse poils Froggy", category: "Hygiène et soins", hygieneSubcategories: "Produits d'hygiène", priceRange: "24,000DT", image: "img/product/brosse-froggy.jpeg" },
  { id: 66, name: "Couches Pour Chien Femelle Taille L - 10 pièces", category: "Hygiène et soins", hygieneSubcategories: "Produits d'hygiène", priceRange: "17,000DT – 25,000DT", image: "img/product/couches-chien-femelle.jpg" },
  { id: 67, name: "GILL’S OTO CLEAN 50ml", category: "Hygiène et soins", hygieneSubcategories: "Produits d'hygiène", priceRange: "22,000DT", image: "img/product/oto-clean.jpg" },
  { id: 68, name: "Lingettes", category: "Hygiène et soins", hygieneSubcategories: "Produits d'hygiène", priceRange: "12,000DT – 19,900DT", image: "img/product/lingettes.jpg" },
  { id: 69, name: "Nettoyant", category: "Hygiène et soins", hygieneSubcategories: "Produits d'hygiène", priceRange: "22,000DT – 32,000DT", image: "img/product/nettoyant.jpeg" },
  { id: 70, name: "Sachets Hygiéniques Parfumés 4*15", category: "Hygiène et soins", hygieneSubcategories: "Produits d'hygiène", priceRange: "9,000DT", image: "img/product/sachets-hygieniques-4x15.jpeg" },
  { id: 71, name: "Sachets Hygiéniques Parfumés 8*15", category: "Hygiène et soins", hygieneSubcategories: "Produits d'hygiène", priceRange: "17,000DT", image: "img/product/sachets-hygieniques-8x15.jpg" },
  { id: 72, name: "Scoop Pince Pliante 66×15,5×13,5 cm", category: "Hygiène et soins", hygieneSubcategories: "Produits d'hygiène", priceRange: "55,000DT", image: "img/product/scoop-pince-pliante.jpg" },
  { id: 73, name: "Support pour Tapis Absorbant 60×60", category: "Hygiène et soins", hygieneSubcategories: "Produits d'hygiène", priceRange: "79,000DT", image: "img/product/support-tapis-absorbant.jpg" },
  { id: 74, name: "Tapis Absorbants au Charbon Actif 60*90 - 30 pièces", category: "Hygiène et soins", hygieneSubcategories: "Produits d'hygiène", priceRange: "29,000DT – 74,000DT", image: "img/product/tapis-absorbants-charbon.png" },
  { id: 75, name: "Anneau Bloom 18cm pour chiots et chiens inférieurs à 12kg", category: "Jouets", priceRange: "29,000DT", image: "img/product/anneau-bloom-18cm.jpg" },
  { id: 76, name: "Balle avec Pointes 9,1cm", category: "Jouets", priceRange: "14,000DT", image: "img/product/balle-pointes-9-1cm.jpg" },
  { id: 77, name: "Balle avec queue en fourrure Jimmy", category: "Jouets", priceRange: "19,000DT", image: "img/product/balle-queue-fourrure-jimmy.jpg" },
  { id: 78, name: "Balle de tennis Canard avec Anneau en corde", category: "Jouets", priceRange: "19,000DT", image: "img/product/balle-tennis-canard-anneau-corde.jpg" },
  { id: 79, name: "Balle de tennis Canard avec manche en corde", category: "Jouets", priceRange: "25,000DT", image: "img/product/balle-tennis-canard-manche-corde.jpg" },
  { id: 80, name: "Balle de tennis Renard 6.5CM", category: "Jouets", priceRange: "15,000DT", image: "img/product/balle-tennis-renard-6-5cm.jpg" },
  { id: 81, name: "Balle de tennis Renard avec Anneau en corde", category: "Jouets", priceRange: "19,000DT", image: "img/product/balle-tennis-renard-anneau-corde.jpg" },
  { id: 82, name: "Balle Rugby flottante", category: "Jouets", priceRange: "29,000DT", image: "img/product/balle-rugby-flottante.jpg" },
  { id: 83, name: "Balle Rugby X-DogTPR M12,5X7X7CM", category: "Jouets", priceRange: "19,000DT", image: "img/product/balle-rugby-xdog-tpr.jpg" },
  { id: 84, name: "Balle TPR S 7,6CM", category: "Jouets", priceRange: "17,000DT", image: "img/product/balle-tpr-s-7-6cm.jpg" },
  { id: 85, name: "Balle X-Dog TPR M8CM", category: "Jouets", priceRange: "19,000DT", image: "img/product/balle-xdog-tpr-m8cm.jpg" },
  { id: 86, name: "Bâton TPR S 24X4,4X4,2CM", category: "Jouets", priceRange: "22,000DT", image: "img/product/baton-tpr-s.jpg", description: "Jouet en forme de bâton en TPR, idéal pour chiens de taille S et M. Surveillez l'état pour éviter accidents." },
  { id: 87, name: "Bazooka + Balles de Tennis", category: "Jouets", priceRange: "115,000DT", image: "img/product/bazooka-balles-tennis.jpg" },
  { id: 88, name: "Bois de Café 90GR C/Corde 28CM S", category: "Jouets", priceRange: "18,000DT", image: "img/product/bois-cafe-90gr.jpeg" },
  { id: 89, name: "Boomerang X-Dog 27,5X12,5X1CM", category: "Jouets", priceRange: "15,000DT", image: "img/product/boomerang-xdog.jpg" },
  { id: 90, name: "Cooling Frisbee", category: "Jouets", priceRange: "27,000DT", image: "img/product/cooling-frisbee.jpg" },
  { id: 91, name: "Cooling Os", category: "Jouets", priceRange: "27,000DT", image: "img/product/cooling-os.jpg" },
  { id: 92, name: "Coto Anneau en Corde 18 cm", category: "Jouets", priceRange: "19,000DT", image: "img/product/coto-anneau-corde.jpg" },
  { id: 93, name: "Distributeur de Friandises Pillon en TPR et Nylon 13X6X4CMR et Nylon 14X9X4CM", category: "Jouets", priceRange: "24,000DT", image: "img/product/distributeur-friandises-pillon.jpg" },
  { id: 94, name: "Distributeur de friandises Saturne", category: "Jouets", priceRange: "25,000DT", image: "img/product/distributeur-friandises-saturne.jpeg" },
  { id: 95, name: "Distributeur de friandises Vice Versa Ball – Saveur Boeuf", category: "Jouets", priceRange: "25,000DT", image: "img/product/distributeur-friandises-viceversa-ball.jpg" },
  { id: 96, name: "Distributeur de friandises Vice Versa Boomerang – Saveur Poulet", category: "Jouets", priceRange: "34,000DT", image: "img/product/distributeur-friandises-viceversa-boomerang.jpg" },
  { id: 97, name: "Distributeur Friandises Petit 7cm", category: "Jouets", priceRange: "22,000DT", image: "img/product/distributeur-friandises-petit.jpeg" },
  { id: 98, name: "DOG TOY PARTY TARTE 12,5X11,5X11CM", category: "Jouets", priceRange: "35,000DT", image: "img/product/dog-toy-party-tarte.jpg" },
  { id: 99, name: "Gamelle Puzzle (Niveau de difficulté 1)", category: "Jouets", priceRange: "27,000DT", image: "img/product/gamelle-puzzle-niveau1.jpg", description: "Stimule mentalement votre chien/chat avec plusieurs compartiments." },
  { id: 100, name: "Gamelle Puzzle (Niveau de difficulté 2)", category: "Jouets", priceRange: "27,000DT", image: "img/product/gamelle-puzzle-niveau2.jpg" },
  { id: 101, name: "Gamelle Puzzle (Niveau de difficulté 3)", category: "Jouets", priceRange: "27,000DT", image: "img/product/gamelle-puzzle-niveau3.jpg" },
  { id: 102, name: "Jouet pour chien Carnivore Boomerang Bone L – Saveur Bacon", category: "Jouets", priceRange: "25,000DT", image: "img/product/carnivore-boomerang-bone-l.jpg" },
  { id: 103, name: "Jouet pour chien Carnivore Boomerang Bone S – Saveur Bacon", category: "Jouets", priceRange: "15,000DT", image: "img/product/carnivore-boomerang-bone-s.jpg" },
  { id: 104, name: "Jouet pour chien Carnivore Drumstick – Saveur Bacon", category: "Jouets", priceRange: "34,000DT", image: "img/product/carnivore-drumstick.jpg" },
  { id: 105, name: "Jouet pour chien Carnivore Meaty Bone M – Saveur Bacon", category: "Jouets", priceRange: "32,000DT", image: "img/product/carnivore-meaty-bone-m.jpg" },
  { id: 106, name: "Jouet pour chien Carnivore Ring Bone L – Saveur Bacon", category: "Jouets", priceRange: "25,000DT", image: "img/product/carnivore-ring-bone-l.jpg" },
  { id: 107, name: "Jouet pour chien Carnivore Ring Bone S – Saveur Bacon", category: "Jouets", priceRange: "17,000DT", image: "img/product/carnivore-ring-bone-s.jpg" },
  { id: 108, name: "Jouet pour chien Carnivore Savory Bone – Saveur Bacon", category: "Jouets", priceRange: "32,000DT", image: "img/product/carnivore-savory-bone.png" },
  { id: 109, name: "Jouet pour chien Carnivore Stick Bone L – Saveur Bacon", category: "Jouets", priceRange: "29,000DT", image: "img/product/carnivore-stick-bone-l.png" },
  { id: 110, name: "Jouet pour chien Carnivore Stick Bone S – Saveur Bacon", category: "Jouets", priceRange: "19,000DT", image: "img/product/carnivore-stick-bone-s.jpg" },
  { id: 111, name: "Mega Dual Balle de Rugby", category: "Jouets", priceRange: "37,000DT", image: "img/product/mega-dual-balle-rugby.jpg" },
  { id: 112, name: "Mega Dual Color Ball", category: "Jouets", priceRange: "49,000DT", image: "img/product/mega-dual-color-ball.jpg" },
  { id: 113, name: "Os Flottant", category: "Jouets", priceRange: "19,000DT", image: "img/product/os-flottant.jpg" },
  { id: 114, name: "Os Funbone – Bleu 18x8x5 cm", category: "Jouets", priceRange: "22,000DT", image: "img/product/os-funbone-bleu.jpeg" },
  { id: 115, name: "Os Funbone – Orange 18x8x5 cm", category: "Jouets", priceRange: "22,000DT", image: "img/product/os-funbone-orange.jpg" },
  { id: 116, name: "Os Large résistant", category: "Jouets", priceRange: "32,000DT", image: "img/product/os-large-resistant.jpg" },
  { id: 117, name: "Os Super Résistant Oxford", category: "Jouets", priceRange: "39,000DT", image: "img/product/os-super-resistant-oxford.jpg" },
  { id: 118, name: "Peluche pour chien Buck 35cm", category: "Jouets", priceRange: "44,000DT", image: "img/product/peluche-buck-35cm.jpg" },
  { id: 119, name: "Peluche pour chien Lars 34cm", category: "Jouets", priceRange: "42,000DT", image: "img/product/peluche-lars-34cm.jpg" },
  { id: 120, name: "Peluche pour chien Thor 30cm", category: "Jouets", priceRange: "34,000DT", image: "img/product/peluche-thor-30cm.jpg" },
  {
    id: 121,
    name: "Cage de transport IATA (STEFANPLAST)",
    category: "Niches et cages",
    brand: "STEFANPLAST",
    priceRange: "259,000DT – 526,500DT",
    description: "Cage de transport pour chien et chat avec roues et longue poignée pliable. Dimensions : Longueur 60cm, Largeur 40cm, Hauteur 45cm",
    image: "img/product/cage-transport-iata.jpg"
  },
  {
    id: 122,
    name: "Cage de Transport Pour Chat et Chien Avec Roues Kim 60",
    category: "Niches et cages",
    priceRange: "119,000DT",
    image: "img/product/cage-transport-kim60.jpeg"
  },
  {
    id: 123,
    name: "Cage Evoque 1 Small porte plastique",
    category: "Niches et cages",
    priceRange: "65,000DT",
    image: "img/product/cage-evoque1-small.jpg"
  },
  {
    id: 124,
    name: "Cage Gipsy (CROCI)",
    category: "Niches et cages",
    brand: "CROCI",
    priceRange: "50,000DT",
    image: "img/product/cage-gipsy-croci.jpg"
  },
  {
    id: 125,
    name: "Cage Vagabond (CROCI)",
    category: "Niches et cages",
    brand: "CROCI",
    priceRange: "182,000DT – 302,000DT",
    image: "img/product/cage-vagabond-croci.jpg"
  },
  {
    id: 126,
    name: "Car Box Cage de voiture (CROCI)",
    category: "Niches et cages",
    brand: "CROCI",
    priceRange: "373,000DT – 669,000DT",
    image: "img/product/car-box-croci.jpg"
  },
  {
    id: 127,
    name: "Imac Dido 50 Coussin pour Chien et Chat Anthracite 50 x 38 x 20,5 cm",
    category: "Niches et cages",
    priceRange: "65,000DT",
    image: "img/product/imac-dido50-coussin.jpg"
  },
  {
    id: 128,
    name: "Maisonnette Vivi 55*55*55",
    category: "Niches et cages",
    priceRange: "199,000DT",
    image: "img/product/maisonnette-vivi.jpg"
  },
  {
    id: 129,
    name: "Niche multifonctions en plastique ZEUS 50",
    category: "Niches et cages",
    priceRange: "129,000DT",
    description: "Niche en plastique robuste pour chien. Dimensions : L 72.2cm x l 61.8cm x H 62.3cm",
    image: "img/product/niche-zeus50.jpg"
  },
  {
    id: 130,
    name: "Niche ZEUS 70",
    category: "Niches et cages",
    priceRange: "270,000DT",
    description: "Niche en plastique robuste pour chien. Dimensions : L 72.2cm x l 61.8cm x H 62.3cm",
    image: "img/product/niche-zeus70.jpg"
  },
  {
    id: 131,
    name: "Panier de Couchage Pablo 93*72cm",
    category: "Niches et cages",
    priceRange: "265,000DT",
    image: "img/product/panier-couchage-pablo.jpg"
  },
  {
    id: 132,
    name: "Sac de Transport Leona 44*24*29 cm",
    category: "Niches et cages",
    priceRange: "159,000DT",
    description: "Sac de transport pour chien et chat, idéal pour voyages. Polyester rembourré, lavable à la main, bandoulière réglable, fond amovible.",
    image: "img/product/sac-transport-leona.jpg"
  },



];

function ShopArea() {
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSubcategory, setSelectedSubcategory] = useState("");
const navigate = useNavigate();

  // Fetch categories and products for 'cat'
  useEffect(() => {
    const fetchCategories = async () => {
      const { data, error } = await supabase
        .from("categories")
        .select("*")
        .eq("pet_type", "dog")
        .order("order", { ascending: true })


      if (error) {
        console.error("Error fetching categories:", error);
      } else {
        setCategories(data);
        if (data.length > 0) {
          setSelectedCategory(data[0].name); // Default category
        }
      }
    };

    const fetchProducts = async () => {
const { data, error } = await supabase
  .from("products")
  .select("id, name, image, price_range, description, category, subcategory");

      if (error) {
        console.error("Error fetching products:", error);
      } else {
        setProducts(data);
      }
    };

    fetchCategories();
    fetchProducts();
  }, []);

  const selectedCategoryObj = categories.find((cat) => cat.name === selectedCategory);
  const subcategories = selectedCategoryObj?.subcategories || [];

  const filteredProducts = products.filter((product) => {
    const matchCategory = product.category === selectedCategory;
    const matchSubcategory = selectedSubcategory
      ? product.subcategory === selectedSubcategory
      : true;
    return matchCategory && matchSubcategory;
  });

  return (
    <div className="shop-area pt-110 pb-110">
      <div className="container">
        <h4 className="title mb-4">Categories</h4>

        {/* Category Cards */}
        <div className="row mb-4">
          {categories.map(cat => {
            const count = products.filter(p => p.category === cat.name).length;
            const isSelected = selectedCategory === cat.name;
            return (
              <div key={cat.name} className="col-lg-3 col-md-4 col-sm-6 mb-3">
                <button
                                    onClick={() => {
      navigate(`/category/${cat.id}/${encodeURIComponent(cat.name)}`);
}}
                  style={{
                            width: "100%",
                          height: "230px",
                    backgroundColor: isSelected ? "#fff" : "#fff",
                    color: isSelected ? "#333" : "#333",
                    border: isSelected ? "2px solid #000" : "1px solid #ddd",
                    borderRadius: "12px",
                    overflow: "hidden",
                    padding: 0,
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: "15px",
                    transition: "all 0.3s ease",
                    boxShadow: isSelected
                      ? "0 4px 10px rgba(0,0,0,0.2)"
                      : "0 2px 6px rgba(0,0,0,0.06)",
                  }}
                >
                  <div style={{ height: "100px", overflow: "hidden" }}>
                                 <img
  src={cat.image}
  alt={cat.name}
  style={{
    width: "40%",
    height: "90%",
    objectFit: "cover",
    marginLeft: window.innerWidth <= 768 ? "200px" : "0px", // shift on mobile
  }}
/>
                  </div>
                  <div style={{ padding: "8px" }}>
                    {cat.name}
                    <div style={{ fontSize: "13px", fontWeight: "normal" }}>
                      {count} produit{count > 1 ? "s" : ""}
                    </div>
                  </div>
                </button>
              </div>
            );
          })}
        </div>

        {/* Subcategory Filter */}
        {subcategories.length > 0 && (
          <div className="subcategory-filter d-flex flex-wrap gap-3 mb-4">
            {subcategories.map(sub => (
              <button
                key={sub}
                onClick={() => setSelectedSubcategory(sub)}
                style={{
                  borderRadius: "16px",
                  padding: "10px 20px",
                  fontSize: "15px",
                  fontWeight: "500",
                  border: selectedSubcategory === sub ? "2px solid #c71585" : "1px solid #ccc",
                  backgroundColor: selectedSubcategory === sub ? "#fce5ef" : "#f9f9f9",
                  color: selectedSubcategory === sub ? "#c71585" : "#333",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                  marginRight: "12px",     // <-- added spacing
                  marginBottom: "12px",    // <-- spacing between rows
                }}

              >
                {sub}
              </button>
            ))}
            <button
              onClick={() => setSelectedSubcategory("")}
              style={{
                borderRadius: "16px",
                padding: "10px 20px",
                fontSize: "15px",
                fontWeight: "500",
                border: selectedSubcategory === "" ? "2px solid #c71585" : "1px solid #ccc",
                backgroundColor: selectedSubcategory === "" ? "#fce5ef" : "#f9f9f9",
                color: selectedSubcategory === "" ? "#c71585" : "#333",
                transition: "all 0.3s ease",
                cursor: "pointer",
                marginRight: "12px",     // <-- added spacing
                marginBottom: "12px",
              }}

            >
              Tous
            </button>
          </div>
        )}

        {/* Product Count */}
        <div className="shop-page-meta mb-30">
          <p>Total Produits {filteredProducts.length}</p>
        </div>

        {/* Products Grid */}
        <div className="row justify-content-center">
          {filteredProducts.length > 0 ? (
            filteredProducts.map(product => (
              <div key={product.id} className="col-lg-3 col-md-4 col-sm-6 mb-4">
                <div
                  className="shop-item"
                  style={{
                    backgroundColor: "#fff",
                    borderRadius: "12px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                    padding: "16px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    height: "100%",
                  }}
                >
                  <div
                    className="shop-thumb"
                    style={{
                      height: "220px",
                      overflow: "hidden",
                      borderRadius: "8px",
                      marginBottom: "1rem",
                    }}
                  >
                    <Link to={`/shop-details/${product.id}`}>
                      <img
                        src={product.image}
                        alt={product.name}
                        style={{
                          width: "70%",
                          height: "90%",
                          objectFit: "cover",
                          display: "block",
                          marginLeft: "auto",
                          marginRight: "auto",
                        }}
                      />
                    </Link>
                  </div>
                  <div className="shop-content">
                    <h5
                      style={{
                        fontSize: "16px",
                        fontWeight: "600",
                        marginBottom: "8px",
                      }}
                    >
                      <Link
                        to={`/shop-details/${product.id}`}
                        style={{ color: "#333", textDecoration: "none" }}
                      >
                        {product.name}
                      </Link>
                    </h5>
                    <div
                      className="shop-content-bottom"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <span
                        className="price"
                        style={{ fontWeight: "bold", color: "#c71585" }}
                      >
                        {product.priceRange}
                      </span>

                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="col-12 text-center mt-4">
              <p className="fs-5">
                🐾{" "}
                {categories.find(c => c.name === selectedCategory)?.emptyMessage ||
                  "Aucun produit trouvé."}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}


export default ShopArea;
